/**
 * Mergensoft Erkek Giyim - Theme Core JavaScript
 * Handles Ajax Cart Drawer, Quick Add, Search Overlay, and Mobile Navigation
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initSearchModal();
  initMobileNav();
  initProductTabs();
  initQuickAddSizes();
  initLanguageSwitcher();
});

/* ==========================================================================
   AJAX CART DRAWER CONTROLLER
   ========================================================================== */
function initCartDrawer() {
  const drawerOverlay = document.getElementById('CartDrawerOverlay');
  const drawerPanel = document.getElementById('CartDrawerPanel');
  const openButtons = document.querySelectorAll('[data-open-cart]');
  const closeButton = document.getElementById('CartDrawerClose');

  if (!drawerPanel) return;

  function openDrawer() {
    drawerOverlay?.classList.add('is-open');
    drawerPanel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawerOverlay?.classList.remove('is-open');
    drawerPanel.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  closeButton?.addEventListener('click', closeDrawer);
  drawerOverlay?.addEventListener('click', closeDrawer);

  window.openThemeCart = openDrawer;
  window.closeThemeCart = closeDrawer;
}

// Fetch Cart Data and Render in Drawer
async function fetchCart() {
  const itemsContainer = document.getElementById('CartDrawerItems');
  const subtotalElement = document.getElementById('CartDrawerSubtotal');
  const badgeElements = document.querySelectorAll('.header-cart-badge');
  const shippingFill = document.getElementById('CartShippingFill');
  const shippingText = document.getElementById('CartShippingText');

  if (!itemsContainer) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update cart counter badges
    badgeElements.forEach(badge => {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    // Update Free Shipping Progress (1500 TRY or 100 EUR/USD etc.)
    const activeCurrency = cart.currency || window.theme?.currency || 'EUR';
    const isTRY = activeCurrency === 'TRY';
    const threshold = isTRY ? 150000 : 10000;
    const progress = Math.min((cart.total_price / threshold) * 100, 100);
    if (shippingFill) {
      shippingFill.style.width = `${progress}%`;
    }
    if (shippingText) {
      if (cart.total_price >= threshold) {
        shippingText.innerHTML = '🎉 Tebrikler! <strong>Ücretsiz Kargo</strong> kazandınız!';
      } else {
        const remaining = threshold - cart.total_price;
        const formattedRemaining = window.themeFormatMoney ? window.themeFormatMoney(remaining) : (remaining / 100).toFixed(2);
        shippingText.innerHTML = `Ücretsiz kargo için <strong>${formattedRemaining}</strong> daha ürün ekleyin!`;
      }
    }

    // Render Items
    if (cart.items.length === 0) {
      itemsContainer.innerHTML = `
        <div style="text-align: center; padding: 40px 10px;">
          <p style="color: #666; font-size: 14px; margin-bottom: 20px;">Sepetiniz henüz boş.</p>
          <a href="/collections/all" class="hero-btn-primary" style="background:#000; color:#fff; display:inline-block; font-size:12px; padding:10px 20px;" onclick="window.closeThemeCart()">Alışverişe Başla</a>
        </div>
      `;
      if (subtotalElement) subtotalElement.textContent = window.themeFormatMoney ? window.themeFormatMoney(0) : '0,00';
      return;
    }

    let itemsHtml = '';
    cart.items.forEach(item => {
      const formattedPrice = window.themeFormatMoney ? window.themeFormatMoney(item.final_line_price) : (item.final_line_price / 100).toFixed(2);
      itemsHtml += `
        <div class="cart-item" data-key="${item.key}">
          <img src="${item.featured_image?.url || ''}" alt="${item.title}" class="cart-item-img">
          <div class="cart-item-info">
            <div>
              <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
              ${item.variant_title ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
              <div class="cart-item-price">${formattedPrice}</div>
            </div>
            <div class="cart-item-qty-row">
              <div class="qty-stepper">
                <button class="qty-btn" onclick="updateCartItemQty('${item.key}', ${item.quantity - 1})">-</button>
                <span class="qty-num">${item.quantity}</span>
                <button class="qty-btn" onclick="updateCartItemQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
              <span class="cart-item-remove" onclick="updateCartItemQty('${item.key}', 0)">Kaldır</span>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHtml;
    if (subtotalElement) {
      subtotalElement.textContent = window.themeFormatMoney ? window.themeFormatMoney(cart.total_price) : (cart.total_price / 100).toFixed(2);
    }

  } catch (err) {
    console.error('Cart fetch error:', err);
  }
}

// Update Item Quantity
window.updateCartItemQty = async function(key, qty) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    fetchCart();
  } catch (e) {
    console.error('Cart update error:', e);
  }
};

// Add to Cart via Ajax
window.themeAddToCart = async function(variantId, quantity = 1) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });

    if (res.ok) {
      if (window.openThemeCart) {
        window.openThemeCart();
      }
    } else {
      const err = await res.json();
      alert(err.description || 'Ürün sepete eklenemedi.');
    }
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

/* ==========================================================================
   QUICK ADD SIZE PILLS ON PRODUCT CARDS
   ========================================================================== */
function initQuickAddSizes() {
  document.addEventListener('click', (e) => {
    const sizeBtn = e.target.closest('.size-pill-btn');
    if (!sizeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = sizeBtn.getAttribute('data-variant-id');
    if (variantId) {
      const originalText = sizeBtn.textContent;
      sizeBtn.textContent = '...';
      window.themeAddToCart(variantId, 1).finally(() => {
        sizeBtn.textContent = originalText;
      });
    }
  });
}

/* ==========================================================================
   SEARCH OVERLAY MODAL
   ========================================================================== */
function initSearchModal() {
  const searchOverlay = document.getElementById('SearchModalOverlay');
  const searchOpenBtn = document.querySelector('[data-open-search]');
  const searchCloseBtn = document.getElementById('SearchModalClose');
  const searchInput = document.getElementById('SearchInputField');

  if (!searchOverlay) return;

  function openSearch() {
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 150);
  }

  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  searchOpenBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  });

  searchCloseBtn?.addEventListener('click', closeSearch);

  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });
}

/* ==========================================================================
   MOBILE NAVIGATION DRAWER
   ========================================================================== */
function initMobileNav() {
  const drawer = document.getElementById('MobileNavDrawer');
  const openBtn = document.querySelector('[data-mobile-menu-toggle]');
  const closeBtn = document.getElementById('MobileNavClose');
  const backdrop = document.getElementById('MobileNavBackdrop');

  if (!drawer) return;

  function openMenu() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtn?.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  backdrop?.addEventListener('click', closeMenu);
}

/* ==========================================================================
   PRODUCT TABS SWITCHER
   ========================================================================== */
function initProductTabs() {
  const tabButtons = document.querySelectorAll('.product-tab-btn');
  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetGridId = btn.getAttribute('data-tab-target');
      
      tabButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      document.querySelectorAll('.products-tab-panel').forEach(panel => {
        if (panel.id === targetGridId) {
          panel.style.display = 'grid';
        } else {
          panel.style.display = 'none';
        }
      });
    });
  });
}

/* ==========================================================================
   MULTI-LANGUAGE SWITCHER HANDLER
   ========================================================================== */
function initLanguageSwitcher() {
  document.addEventListener('click', (e) => {
    const isLangClick = e.target.closest('.lang-dropdown-container');
    if (!isLangClick) {
      document.querySelectorAll('.lang-dropdown-container.is-open').forEach(el => {
        el.classList.remove('is-open');
      });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.lang-dropdown-container.is-open').forEach(el => {
        el.classList.remove('is-open');
      });
    }
  });
}

